export default __webpack_public_path__ + "static/media/UniversLTStd.42cfb949.woff2";